// ============================================================================
// ClientPortalApp — the layout root for the whole /client + /me realm. Wraps the
// portal subtree in its OWN ClientAuthProvider (separate from the trainer
// AuthProvider) so the two auth contexts never overlap, then renders the matched
// portal route via <Outlet/>. Mounted as a single layout route in the main
// router; the trainer /app tree is unaffected.
// ============================================================================
import { Outlet } from "react-router-dom";
import { ClientAuthProvider } from "./auth/ClientAuthContext";

export function ClientPortalApp() {
  return (
    <ClientAuthProvider>
      <Outlet />
    </ClientAuthProvider>
  );
}
